import React from "react";
import {
  ToggleButton,
  ToggleButtonGroup,
} from "Components/Base/Inputs/ToggleButton";
import { FilterListIcon, FilterResetIcon } from "Components/Icons";
import { useFilter } from "../context";

const ToggleButtonGroupFilter = ({ languageContext, displayClearButton }) => {
  const { toggleDrawer, handleClearFilter } = useFilter();

  return (
    <ToggleButtonGroup exclusive>
      <ToggleButton
        onClick={toggleDrawer}
        title={languageContext("filter")}
        aria-label={languageContext("filter")}
        value={true}
      >
        <FilterListIcon />
      </ToggleButton>
      <ToggleButton
        onClick={handleClearFilter}
        title={languageContext("clearFilters")}
        aria-label={languageContext("clearFilters")}
        value={false}
        disabled={!displayClearButton}
      >
        <FilterResetIcon />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ToggleButtonGroupFilter;
